export default __webpack_public_path__ + "static/media/runeofaggression.4d814477.png";